import { cn } from "@/lib/utils";
import { RiImage2Line, RiMovieLine } from "@remixicon/react";

interface Props {
  type: "image" | "video" | "mixed";
  size?: number;
  radius?: number;
  iconClassName?: string;
  className?: string;
  variant?: "raw" | "full"; // Use "full" for masked icons, "raw" for plain icons.
}

const MixedIconSvg = ({
  size = 20,
  className,
  color,
}: {
  size?: number;
  className?: string;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <foreignObject x="-4.44444" y="-4.44444" width="28.8889" height="28.8889">
      <div
        style={{
          backdropFilter: "blur(2.22px)",
          clipPath: "url(#bgblur_0_38132_47776_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="4.44444">
      <rect width="20" height="20" rx="4.44444" fill="#5344FFB2" fill-opacity="0.7" />
      <g clip-path="url(#clip1_38132_47776)">
        <path
          d="M9.52245 5.52666C9.08722 5.52666 8.74266 5.86737 8.74266 6.28446C8.74266 6.70154 9.09327 7.04225 9.52245 7.04225C9.95164 7.04225 10.3022 6.70154 10.3022 6.28446C10.3022 5.86737 9.9456 5.52666 9.52245 5.52666ZM10.9491 10.0852C10.9491 10.0852 10.8946 10.0852 10.8705 10.1028L11.348 10.5669V11.6184H10.7435V12.6347H11.8679C12.152 12.6347 12.3877 12.4056 12.3877 12.1295V10.9898L11.0639 10.1322C11.0276 10.1087 10.9853 10.0969 10.9491 10.0969V10.0852ZM11.8679 3.5H3.51986C3.22971 3.5 3 3.7291 3 4.0052V12.1177C3 12.3938 3.22971 12.6229 3.51986 12.6229H7.61226V11.6066H7.13472L7.61226 11.1426V9.04541L6.56649 8.02915L5.08549 6.58992L4.03972 7.60619V4.51627H11.342V8.38748H12.3877V4.0052C12.3877 3.7291 12.152 3.5 11.8679 3.5ZM5.08549 8.02915L6.56649 9.46837L7.2133 10.0969L6.56649 10.7255L5.65976 11.6125H4.04577V9.03954L5.09154 8.02327L5.08549 8.02915ZM8.97841 8.38748H10.5864L9.78238 7.60619L8.97841 8.38748ZM10.3022 6.29033C10.3022 5.86737 9.9456 5.53254 9.52245 5.53254C9.09931 5.53254 8.74266 5.87325 8.74266 6.29033C8.74266 6.70741 9.09327 7.04812 9.52245 7.04812C9.95164 7.04812 10.3022 6.70741 10.3022 6.29033ZM9.78238 7.60619L8.97841 8.38748H10.5864L9.78238 7.60619ZM10.3022 6.29033C10.3022 5.86737 9.9456 5.53254 9.52245 5.53254C9.09931 5.53254 8.74266 5.87325 8.74266 6.29033C8.74266 6.70741 9.09327 7.04812 9.52245 7.04812C9.95164 7.04812 10.3022 6.70741 10.3022 6.29033Z"
          fill={color || "white"}
        />
        <path
          d="M13.609 11.7651L12.388 10.9721L11.0641 10.1144C11.0278 10.0909 10.9855 10.0792 10.9493 10.0792C10.9251 10.0792 10.8949 10.0792 10.8707 10.0968C10.7981 10.1262 10.7437 10.2025 10.7437 10.2848V13.5862C10.7437 13.6214 10.7558 13.6626 10.774 13.6978C10.8344 13.7918 10.9674 13.8153 11.0641 13.7507L13.609 12.1058C13.609 12.1058 13.6513 12.0706 13.6634 12.053C13.7239 11.959 13.6997 11.8297 13.609 11.771V11.7651ZM13.609 11.7651L12.388 10.9721L11.0641 10.1144C11.0278 10.0909 10.9855 10.0792 10.9493 10.0792C10.9251 10.0792 10.8949 10.0792 10.8707 10.0968C10.7981 10.1262 10.7437 10.2025 10.7437 10.2848V13.5862C10.7437 13.6214 10.7558 13.6626 10.774 13.6978C10.8344 13.7918 10.9674 13.8153 11.0641 13.7507L13.609 12.1058C13.609 12.1058 13.6513 12.0706 13.6634 12.053C13.7239 11.959 13.6997 11.8297 13.609 11.771V11.7651ZM16.4804 7.37109H7.08657C6.80246 7.37109 6.57275 7.60019 6.57275 7.87629V15.9947C6.57275 16.2708 6.80246 16.494 7.08657 16.494H16.4804C16.7645 16.494 17.0002 16.2708 17.0002 15.9947V7.88216C17.0002 7.60607 16.7645 7.37697 16.4804 7.37697V7.37109ZM15.9605 15.4836H7.61248V8.38736H15.9605V15.4836ZM11.0641 10.1203C11.0278 10.0968 10.9855 10.0851 10.9493 10.0851C10.9251 10.0851 10.8949 10.0851 10.8707 10.1027C10.7981 10.1321 10.7437 10.2084 10.7437 10.2907V13.5921C10.7437 13.6273 10.7558 13.6684 10.774 13.7037C10.8344 13.7977 10.9674 13.8212 11.0641 13.7565L13.609 12.1117C13.609 12.1117 13.6513 12.0765 13.6634 12.0588C13.7239 11.9649 13.6997 11.8356 13.609 11.7769L12.388 10.9838L11.0641 10.1262V10.1203Z"
          fill={color || "white"}
        />
      </g>
    </g>
    <defs>
      <clipPath
        id="bgblur_0_38132_47776_clip_path"
        transform="translate(4.44444 4.44444)"
      >
        <rect width="20" height="20" rx="4.44444" />
      </clipPath>
      <clipPath id="clip1_38132_47776">
        <rect width="14" height="13" fill="white" transform="translate(3 3.5)" />
      </clipPath>
    </defs>
  </svg>
);

const RawMixedIconSvg = ({
  size = 14,
  className,
  color,
}: {
  size?: number;
  className?: string;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_38147_51476)">
      <path
        d="M6.52245 2.52666C6.08722 2.52666 5.74266 2.86737 5.74266 3.28446C5.74266 3.70154 6.09327 4.04225 6.52245 4.04225C6.95164 4.04225 7.30225 3.70154 7.30225 3.28446C7.30225 2.86737 6.9456 2.52666 6.52245 2.52666ZM7.94905 7.08518C7.94905 7.08518 7.89465 7.08518 7.87047 7.1028L8.34801 7.56688V8.61839H7.74352V9.63466H8.86788C9.15199 9.63466 9.38774 9.40556 9.38774 9.12946V7.98983L8.0639 7.13217C8.02763 7.10868 7.98532 7.09693 7.94905 7.09693V7.08518ZM8.86788 0.5H0.519862C0.229706 0.5 0 0.729101 0 1.0052V9.11771C0 9.39381 0.229706 9.62291 0.519862 9.62291H4.61226V8.60664H4.13472L4.61226 8.14257V6.04541L3.56649 5.02915L2.08549 3.58992L1.03972 4.60619V1.51627H8.34197V5.38748H9.38774V1.0052C9.38774 0.729101 9.15199 0.5 8.86788 0.5ZM2.08549 5.02915L3.56649 6.46837L4.2133 7.09693L3.56649 7.72549L2.65976 8.61252H1.04577V6.03954L2.09154 5.02327L2.08549 5.02915ZM5.97841 5.38748H7.58636L6.78238 4.60619L5.97841 5.38748ZM7.30225 3.29033C7.30225 2.86737 6.9456 2.53254 6.52245 2.53254C6.09931 2.53254 5.74266 2.87325 5.74266 3.29033C5.74266 3.70741 6.09327 4.04812 6.52245 4.04812C6.95164 4.04812 7.30225 3.70741 7.30225 3.29033ZM6.78238 4.60619L5.97841 5.38748H7.58636L6.78238 4.60619ZM7.30225 3.29033C7.30225 2.86737 6.9456 2.53254 6.52245 2.53254C6.09931 2.53254 5.74266 2.87325 5.74266 3.29033C5.74266 3.70741 6.09327 4.04812 6.52245 4.04812C6.95164 4.04812 7.30225 3.70741 7.30225 3.29033Z"
        fill={color || "white"}
      />
      <path
        d="M10.609 8.76513L9.38795 7.97209L8.06412 7.11443C8.02785 7.09093 7.98553 7.07918 7.94927 7.07918C7.92509 7.07918 7.89486 7.07918 7.87068 7.09681C7.79814 7.12618 7.74374 7.20254 7.74374 7.28479V10.5862C7.74374 10.6214 7.75583 10.6626 7.77396 10.6978C7.83441 10.7918 7.9674 10.8153 8.06412 10.7507L10.609 9.10584C10.609 9.10584 10.6513 9.0706 10.6634 9.05297C10.7239 8.95898 10.6997 8.82975 10.609 8.771V8.76513ZM10.609 8.76513L9.38795 7.97209L8.06412 7.11443C8.02785 7.09093 7.98553 7.07918 7.94927 7.07918C7.92509 7.07918 7.89486 7.07918 7.87068 7.09681C7.79814 7.12618 7.74374 7.20254 7.74374 7.28479V10.5862C7.74374 10.6214 7.75583 10.6626 7.77396 10.6978C7.83441 10.7918 7.9674 10.8153 8.06412 10.7507L10.609 9.10584C10.609 9.10584 10.6513 9.0706 10.6634 9.05297C10.7239 8.95898 10.6997 8.82975 10.609 8.771V8.76513ZM13.4804 4.37109H4.08657C3.80246 4.37109 3.57275 4.60019 3.57275 4.87629V12.9947C3.57275 13.2708 3.80246 13.494 4.08657 13.494H13.4804C13.7645 13.494 14.0002 13.2708 14.0002 12.9947V4.88216C14.0002 4.60607 13.7645 4.37697 13.4804 4.37697V4.37109ZM12.9605 12.4836H4.61248V5.38736H12.9605V12.4836ZM8.06412 7.1203C8.02785 7.09681 7.98553 7.08506 7.94927 7.08506C7.92509 7.08506 7.89486 7.08506 7.87068 7.10268C7.79814 7.13205 7.74374 7.20842 7.74374 7.29066V10.5921C7.74374 10.6273 7.75583 10.6684 7.77396 10.7037C7.83441 10.7977 7.9674 10.8212 8.06412 10.7565L10.609 9.11172C10.609 9.11172 10.6513 9.07647 10.6634 9.05885C10.7239 8.96486 10.6997 8.83562 10.609 8.77688L9.38795 7.98384L8.06412 7.12618V7.1203Z"
        fill={color || "white"}
      />
    </g>
    <defs>
      <clipPath id="clip0_38147_51476">
        <rect width="14" height="13" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const MediaIcon = ({
  type,
  size = 20,
  radius = 4.44,
  className,
  iconClassName,
  variant = "full",
}: Props) => {
  let icon = null;
  const squircleRadiusClass = cn(
    "squircle-radius-[4.44px]",
    radius !== 4.44 && `squircle-radius-[${radius}px]`,
  );
  switch (type) {
    case "image":
      icon = (
        <span
          className={cn(
            `flex items-center justify-center squircle squircle-fill-[#FF4699B2] squircle-smooth-[1] backdrop-blur-[4.44px] shrink-0`,
            squircleRadiusClass,
            className,
          )}
          style={{
            height: `${size}px`,
            width: `${size}px`,
          }}
        >
          <RiImage2Line size={size - 6} className={cn("text-white", iconClassName)} />
        </span>
      );
      break;
    case "video":
      icon = (
        <span
          className={cn(
            `flex items-center justify-center squircle squircle-fill-[#018C62B2] squircle-smooth-[1] backdrop-blur-[4.44px] shrink-0`,
            squircleRadiusClass,
            className,
          )}
          style={{
            height: `${size}px`,
            width: `${size}px`,
          }}
        >
          <RiMovieLine size={size - 6} className={cn("text-white", iconClassName)} />
        </span>
      );
      break;
    case "mixed":
      icon = <MixedIconSvg size={size} className={className} color="white" />;
      break;
    default:
      icon = <MixedIconSvg size={size} className={className} color="white" />;
  }
  if (variant === "full")
    return <span className="squircle-mask backdrop-blur-[4.44px]">{icon}</span>;

  switch (type) {
    case "image":
      icon = (
        <RiImage2Line
          color="#FF4699"
          size={size}
          className={cn("text-white shrink-0", className)}
        />
      );
      break;
    case "video":
      icon = (
        <RiMovieLine
          color="#018C62"
          size={size}
          className={cn("text-white shrink-0", className)}
        />
      );
      break;
    case "mixed":
      icon = <RawMixedIconSvg size={size - 1} className={className} color="#5344FF" />;
      break;
    default:
      icon = <RawMixedIconSvg size={size - 1} className={className} color="white" />;
  }
  return icon;
};

export default MediaIcon;
